import { _breakP } from '../../js/lib/utils.js';
import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Autoplay,
  A11y,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  EffectFlip,
  EffectCards,
  EffectCreative
} from 'swiper/modules';

export default class generalSlider {
  constructor() {
    this.generalSliderFunc();
  }
  generalSliderFunc() {
    const $generalSlider = document.querySelectorAll('.js-generalSlider');

    if ($generalSlider.length) {
      $generalSlider.forEach((elm, i) => {
        const elSlideLength = elm.querySelectorAll('.swiper-slide').length;
        const minSliderLength = _breakP.SP
          ? Number(elm.dataset.spMinSlides)
          : Number(elm.dataset.pcMinSlides);

        // data属性からオプションを取得
        // PC/SPで別々にloop設定（初期化時のブレークポイントで判定）
        const hasLoop = _breakP.SP
          ? elm.dataset.spLoop === 'true'
          : elm.dataset.pcLoop === 'true';
        const hasNavigation = elm.dataset.navigation === 'true';
        const hasPagination = elm.dataset.pagination === 'true';
        const hasAutoplay = elm.dataset.autoplay === 'true';
        const effect = elm.dataset.effect || 'slide';

        const effectModuleMap = {
          fade: EffectFade,
          cube: EffectCube,
          coverflow: EffectCoverflow,
          flip: EffectFlip,
          cards: EffectCards,
          creative: EffectCreative
        };

        const slideInit = () => {
          const imgArr = elm.querySelectorAll('.swiper-slide img');
          imgArr.forEach(img => {
            if (img.classList.contains('lazy')) {
              img.setAttribute('src', img.dataset.src);
              img.classList.remove('lazy');
            }
          });

          elm.classList.add('generalSlider--' + i);

          // loop用: スライドを複製してSwiper loopに必要な枚数を確保
          const originalSlideCount = elSlideLength;
          if (hasLoop) {
            const wrapper = elm.querySelector('.swiper-wrapper');
            const originalSlides = Array.from(
              wrapper.querySelectorAll(':scope > .swiper-slide')
            );
            originalSlides.forEach((slide, idx) => {
              slide.setAttribute('data-slide-index', idx);
              slide.setAttribute('data-original', '');
            });
            originalSlides.forEach(slide => {
              const clone = slide.cloneNode(true);
              clone.removeAttribute('data-original');
              clone.setAttribute('aria-hidden', 'true');
              wrapper.appendChild(clone);
            });
          }

          let generalSlider;
          let sliderInitialized = false;

          // 使用するモジュールを動的に設定
          const modules = [A11y];
          if (hasNavigation) modules.push(Navigation);
          if (hasPagination) modules.push(Pagination);
          if (hasAutoplay) modules.push(Autoplay);
          if (effectModuleMap[effect]) modules.push(effectModuleMap[effect]);

          const fixLoopSlideA11y = swiper => {
            swiper.slides.forEach(slide => {
              if (slide.hasAttribute('data-original')) {
                slide.removeAttribute('aria-hidden');
                const idx = Number(slide.getAttribute('data-slide-index'));
                slide.setAttribute(
                  'aria-label',
                  `${idx + 1} / ${originalSlideCount}`
                );
              } else {
                slide.setAttribute('aria-hidden', 'true');
                slide.removeAttribute('aria-label');
              }
            });
          };

          const swiperOptions = {
            modules,
            loop: hasLoop,
            slidesPerView: 'auto',
            spaceBetween: Number(elm.dataset.spSpaceBetween),
            speed: 2000,
            simulateTouch: true,
            allowTouchMove: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            centeredSlides: elm.dataset.spCenterMode === 'on',
            breakpoints: {
              768: {
                spaceBetween: Number(elm.dataset.pcSpaceBetween),
                centeredSlides: elm.dataset.pcCenterMode === 'on'
              }
            },
            a11y: {
              enabled: true,
              prevSlideMessage: '前のスライドへ',
              nextSlideMessage: '次のスライドへ',
              paginationBulletMessage: '{{index}}枚目のスライドを表示'
            }
          };

          // Effect設定
          if (effect !== 'slide') {
            swiperOptions.effect = effect;
            if (effect === 'fade') {
              swiperOptions.fadeEffect = { crossFade: true };
            }
          }

          let paginationElRef = null;
          // Pagination設定（el はインスタンス直下で一意に解決。複数 .swiper-pagination が無い前提）
          if (hasPagination) {
            paginationElRef = elm.querySelector('.swiper-pagination');
            if (paginationElRef) {
              if (hasLoop) {
                const renderLoopPaginationHtml = swiper => {
                  const params = swiper.params.pagination;
                  const tag = params.bulletElement || 'span';
                  const bc = params.bulletClass;
                  const bacTokens = params.bulletActiveClass.trim().split(/\s+/);
                  const activeSlide = swiper.slides[swiper.activeIndex];
                  let logicalIndex = swiper.realIndex;
                  if (activeSlide?.hasAttribute('data-slide-index')) {
                    logicalIndex = Number(
                      activeSlide.getAttribute('data-slide-index')
                    );
                  } else if (originalSlideCount > 0) {
                    logicalIndex =
                      ((swiper.realIndex % originalSlideCount) +
                        originalSlideCount) %
                      originalSlideCount;
                  }
                  let html = '';
                  for (let idx = 0; idx < originalSlideCount; idx++) {
                    const isActive = idx === logicalIndex;
                    const classAttr = isActive
                      ? `${bc} ${bacTokens.join(' ')}`
                      : bc;
                    html += `<${tag} class="${classAttr}" role="button" tabindex="0" aria-label="${idx + 1}枚目のスライドを表示"${isActive ? ' aria-current="true"' : ''}></${tag}>`;
                  }
                  return html;
                };
                swiperOptions.pagination = {
                  el: paginationElRef,
                  type: 'custom',
                  clickable: true,
                  renderCustom(swiper) {
                    return renderLoopPaginationHtml(swiper);
                  }
                };
              } else {
                swiperOptions.pagination = {
                  el: paginationElRef,
                  clickable: true
                };
              }
            }
          }

          if (hasLoop) {
            let paginationKeydownHandler = null;
            swiperOptions.on = {
              init(swiper) {
                fixLoopSlideA11y(swiper);
                if (hasPagination && paginationElRef) {
                  const bulletClassToken =
                    swiper.params.pagination.bulletClass.trim().split(/\s+/)[0];
                  paginationKeydownHandler = e => {
                    if (e.key !== 'Enter' && e.key !== ' ') return;
                    if (
                      !bulletClassToken ||
                      !e.target.classList.contains(bulletClassToken)
                    ) {
                      return;
                    }
                    if (!paginationElRef.contains(e.target)) return;
                    e.preventDefault();
                    e.target.click();
                  };
                  paginationElRef.addEventListener(
                    'keydown',
                    paginationKeydownHandler
                  );
                }
              },
              beforeDestroy() {
                if (paginationKeydownHandler && paginationElRef) {
                  paginationElRef.removeEventListener(
                    'keydown',
                    paginationKeydownHandler
                  );
                  paginationKeydownHandler = null;
                }
              },
              slideChange(swiper) {
                fixLoopSlideA11y(swiper);
              }
            };
          }

          // Navigation設定
          if (hasNavigation) {
            swiperOptions.navigation = {
              nextEl: `.generalSlider--${i} .js-generalSliderNext`,
              prevEl: `.generalSlider--${i} .js-generalSliderPrev`
            };
          }

          // Autoplay設定
          if (hasAutoplay) {
            swiperOptions.autoplay = {
              delay: 4000,
              disableOnInteraction: false
            };
          }

          const sliderSet = () => {
            const intersectionCallback = entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting && !sliderInitialized) {
                  generalSlider = new Swiper(
                    `.generalSlider--${i} .swiper`,
                    swiperOptions
                  );
                  sliderInitialized = true;
                }
              });
            };
            const io = new IntersectionObserver(intersectionCallback, {
              rootMargin: '0px 0px'
            });
            io.observe(elm);
          };

          sliderSet();

          const targetNode = elm.closest('.js-sliderReset');
          if (targetNode) {
            const mutationCallback = mutationsList => {
              mutationsList.forEach(mutation => {
                if (
                  mutation.type === 'attributes' &&
                  mutation.attributeName === 'class'
                ) {
                  if (targetNode.classList.contains('is-active')) {
                    if (!generalSlider || generalSlider.destroyed) {
                      sliderSet();
                    }
                  } else if (generalSlider && !generalSlider.destroyed) {
                    generalSlider.destroy(true, true);
                    sliderInitialized = false;
                  }
                }
              });
            };
            const mo = new MutationObserver(mutationCallback);
            mo.observe(targetNode, { attributes: true });
          }
        };

        const slideDisable = () => {
          elm.classList.add('generalSlider--disableMode');
        };

        elSlideLength >= minSliderLength ? slideInit() : slideDisable();
      });
    }
  }
}
